/**
 * Created by vsuthar on 9/24/21
 * File: LicenseRenderer
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useMemo } from 'react'
import {
  APP_ID_TO_UNIT,
  APP_TO_ALIAS,
  APP_ID_TO_NAME,
  LABEL_NOT_APPLICABLE,
  APP_UNITS,
  DO_NOT_RENDER_UNITS,
  DO_NOT_RENDER_DUPLICATES,
  REMOTE_NETWORK_LABEL,
  MOBILE_USERS_LABEL
} from '../common/GlobalConstants'
import { Body, Bold } from '@panwds/react-ui'
import {
  APP_ID_LOGGING_SERVICE,
  APP_ID_PRISMA_ACCESS_EDITION,
  APP_ID_PRISMA_SAAS, APP_ID_PRIVATE_APPS, MULTIPLE_APPID,
  APP_ID_PRISMA_ACCESS_EDITION_ONPREM
} from '../common/GlobalConstants'
import appNames from '../common/appNames'
import { ARRAY, isBundledProduct } from '../common/utils'

const LicenseRenderer = (props: any) => {
  const { value: _value, row, apps = {} } = props
  const [entitlements, original] = useMemo(() => {
    let entitlements = _value
    let original = row?.original
    if (row?.depth === 0 && ARRAY.hasArray(row?.subRows) && !row?.isExpanded) {
      original = row?.subRows[0]?.original
      entitlements = original?.entitlements
    }
    if (row?.original?.app_id === APP_ID_PRISMA_SAAS) {
      entitlements = []
    }
    return [entitlements, original]
  }, [_value, row?.original, row?.depth, row?.subRows, row?.isExpanded])


  const getAppIdToName = useCallback((app_id, purchaseSize, type: string) => {
    const name = (app_id === APP_ID_PRISMA_ACCESS_EDITION || app_id === APP_ID_PRISMA_ACCESS_EDITION_ONPREM) ? '' : `${appNames(apps).getAppName(app_id, APP_ID_TO_NAME[app_id])} `
    return <Body size='xs'><Bold>{`${name}${type}`}</Bold>{`: ${purchaseSize} ${APP_UNITS[type]}`}</Body>
  }, [apps])

  const value = useMemo(() => {
    if (original?.app_id === APP_ID_LOGGING_SERVICE) {
      const purchased_size = original?.extra?.purchased_size || original?.entitlements[0]?.purchased_size || 'NA'
      return [{ app_id: APP_ID_LOGGING_SERVICE, purchased_size }]
    }
    const addedEntitlements = new Set<string>([])
    const uniqueEntitlements: Array<any> = []
    entitlements?.forEach((each: any) => {
      if (DO_NOT_RENDER_DUPLICATES.has(each?.app_id) && !addedEntitlements.has(each?.app_id)) {
        uniqueEntitlements.push(each)
        addedEntitlements.add(each?.app_id)
      }
      else if (!DO_NOT_RENDER_DUPLICATES.has(each?.app_id)) {
        uniqueEntitlements.push(each)
      }
    })
    return uniqueEntitlements.length ? uniqueEntitlements : ''
  }, [original, entitlements])

  const getQuantity = (license: any) => {
    const licenseType = license?.license_type
    const app_id = license?.app_id
    const purchased_size = license?.purchased_size
    // if (app_id === APP_ID_PRIVATE_APPS) {
    //   const private_apps_qty = original?.entitlements?.find((each) => each.app_id === APP_ID_PRIVATE_APPS_QTY)
    //   purchased_size = purchased_size + (private_apps_qty ? private_apps_qty.purchased_size : 0)
    // }
    if (MULTIPLE_APPID.includes(app_id)) {
      if (licenseType.toUpperCase().includes('MU-RN')) {
        return <div className={'tw-flex tw-flex-col'}>
          {getAppIdToName(app_id, purchased_size, REMOTE_NETWORK_LABEL)}
          {getAppIdToName(app_id, purchased_size, MOBILE_USERS_LABEL) }
        </div>
      }
      else if (licenseType.toUpperCase().includes('MU')) {
        return getAppIdToName(app_id, purchased_size, MOBILE_USERS_LABEL)
      }
      else if (licenseType.toUpperCase().includes('RN')) {
        return getAppIdToName(app_id, purchased_size, REMOTE_NETWORK_LABEL)
      }
    }
    else if (DO_NOT_RENDER_UNITS.has(app_id)) {
      return <Body size='xs'>{APP_TO_ALIAS?.[app_id] || appNames(apps).getAppName(app_id, APP_ID_TO_NAME[app_id])}</Body>
    }
    else if (isBundledProduct(apps, app_id)) {
      return <Body size='xs'><Bold>{license?.license_display_name}</Bold>{`: ${purchased_size || 'NA'} ${APP_ID_TO_UNIT[app_id] || ''}`}</Body>
    }
    else if (app_id !== APP_ID_PRIVATE_APPS && appNames(apps).getAppName(app_id, APP_ID_TO_NAME[app_id])) {
      return <Body size='xs'><Bold>{APP_TO_ALIAS?.[app_id] || appNames(apps).getAppName(app_id, APP_ID_TO_NAME[app_id])}</Bold>{`: ${purchased_size || 'NA'} ${APP_ID_TO_UNIT[app_id] || ''}`}</Body>
    }
    else if (app_id !== APP_ID_PRIVATE_APPS) {
      return <Body size='xs'>{app_id}: {purchased_size || 'NA'}</Body>
    }
  }

  return (
    <div className="tw-relative tw-h-full">
      {Array.isArray(value) ? <div className='tw-flex tw-flex-col tw-gap-0.5'>{
        value?.map((each, i) => (<div className='tw-flex tw-flex-col' key={i}>{getQuantity(each)}</div>))
      }</div> : <Body size='xs' addClassName='tw-truncate'>{LABEL_NOT_APPLICABLE}</Body>}
    </div>
  )
}

LicenseRenderer.propTypes = {}
export default LicenseRenderer

